import React from 'react'
import { init } from 'tools/lib'

const useIntersection = ({ root, rootMargin, threshold, disabled } = {}) => {
  const observer = React.useRef()
  const [isPolyfillLoaded, setIsPolyfillLoaded] = React.useState(false)
  const [target, setTarget] = React.useState()
  const [entry, setEntry] = React.useState()

  const observeIntersection = React.useCallback(() => {
    if (disabled) return

    if (!observer.current) {
      observer.current = new window.IntersectionObserver(
        ([entry]) => setEntry(entry),
        { root, rootMargin, threshold }
      )
    }

    if (target) {
      observer.current.observe(target)
    }

    return () => {
      observer.current && observer.current.disconnect()
    }
  }, [disabled, root, rootMargin, target, threshold])

  React.useEffect(() => {
    if ('IntersectionObserver' in window) {
      return observeIntersection()
    }
  }, [observeIntersection])

  // Cross-browser compatibility
  React.useEffect(() => {
    if ('IntersectionObserver' in window) return

    init(
      'https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver',
      'IntersectionObserverPolyfill'
    ).then(() => {
      setIsPolyfillLoaded(true)
    })
  }, [])

  React.useEffect(() => {
    if (isPolyfillLoaded) {
      return observeIntersection()
    }
  }, [isPolyfillLoaded, observeIntersection])

  return [entry, setTarget]
}

export default useIntersection
